import script from "./SuccessPayment.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuccessPayment.vue?vue&type=script&setup=true&lang=ts"

import "./SuccessPayment.vue?vue&type=style&index=0&id=d5386048&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5386048"]])

export default __exports__